import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { typography } from './../../../styles';
import StyledType from '../../type/type.styles';
var defaultStyles = /*#__PURE__*/css("flex-basis:auto;width:100%;", StyledType, "{font-size:", typography.typographyBodyXs, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var StyledFormFieldHintText = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e14bhsc10"
} : {
  target: "e14bhsc10",
  label: "StyledFormFieldHintText"
})(defaultStyles);
export default StyledFormFieldHintText;